import classNames from "classnames";
import st from "./RdcCard.module.scss";

interface IRdcCardProps extends React.HTMLAttributes<HTMLDivElement> {
	dir?: "col" | "row";
	wrap?: boolean;
	noteMargin?: boolean;
};

/** Компонента-контейнер для отображения блока */
export const RdcCard: React.FC<IRdcCardProps> = ( { className, children, wrap = false, noteMargin = false, dir = "col", ...otherProps } ) => (
	<div 
		className={ classNames(st.rdc_card, className, "body-large", { 
			'flex-row': dir === "row",
			'flex-column': dir === "col",
			[st.noteMargin]: !!noteMargin,
			[st.wrap]: wrap
		}) }
		{...otherProps}
	>
		{children}
	</div>
);
